import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { IncomingMessage, ServerResponse } from 'node:http';
import slugQuery from './queries/jobs/jobSlugQuery.graphql';
import redirectJobSlug from './redirectJobSlug';
import getJobsLocale from './getJobsLocale';
import isDashboard from './isDashboard.mjs';
import getUrlFromRequest from './getUrlFromRequest.mjs';
import throw404 from './throw404';

export interface IncomingMessageWithLocale extends IncomingMessage {
  locale?: string;
}

export interface ServerResponseWithStatus extends ServerResponse {
  status?: (statusCode: number) => ServerResponseWithStatus;
}

const getRedirectJob = (
  routeStem: string,
) => (async (context: {
  req?: IncomingMessageWithLocale;
  res?: ServerResponseWithStatus;
  apolloClient: ApolloClient<NormalizedCacheObject>;
  query: {
    id: string;
    slug: string;
    prefix?: string;
    companySlug?: string;
  };
}) => {
  const {
    req,
    apolloClient,
    query: {
      id,
      slug,
      prefix,
      companySlug,
    },
    res,
  } = context;

  if (!req) {
    return {};
  }

  if (isDashboard(getUrlFromRequest(req))) {
    return throw404();
  }

  const { locale } = req;
  const { data: { job } } = await apolloClient.query({
    query: slugQuery,
    variables: {
      locales: [getJobsLocale(locale)],
      id: Number(id),
    },
    fetchPolicy: 'network-only',
  });

  if (!job && res?.status) {
    res.status(410);
  }

  return redirectJobSlug(
    job,
    slug,
    id,
    prefix,
    `${routeStem}.${locale}`,
    res,
    companySlug,
  );
});

export default getRedirectJob;
